import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showRouterBar:false,
    showBreadcrumb:false,
    showFooter:false
  },
  mutations: {
    // 首页页脚
    changeshowFooterState(state,value){
      state.showFooter = value
    },
    // 面包屑显示/隐藏状态
    changeShowBreadcrumbState(state,value){
      state.showBreadcrumb = value
    },
    // 路由组件显示/隐藏状态
    changeShowshowRouterBarState(state,value){
      state.showRouterBar = value
    },
  },
  actions: {},
  modules: {}
});
